<template>
  <section>
    <div id="pop" class="modal-card" style="width: auto">
      <header class="modal-card-head footerSourceModal-head">
        <p class="modal-card-title footerSourceModal-title">FAQ</p>
      </header>
      <section id="printBody" ref="PrintBody" class="modal-card-body footerSourceModal">
        <div v-html="$t('faq.faq_pop')"></div>
        <!--
        <hr>
        <div v-html="$t('faq.faq_general')"></div>
        -->
      </section>
      <footer class="modal-card-foot footerSourceModal-foot">
        <b-button class="button" @click="print()">{{$t('faq.print_text')}}</b-button>
        <b-button class="button" @click="$parent.close()">{{$t('faq.close_text')}}</b-button>
      </footer>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import { Modal} from "buefy";
import Printd from "printd";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
Vue.use(Modal);
// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: 'en',
})

export default {
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_pop: `
            <h2 class="is-size-4">Population, by Gender and Age</h2>
            <h3 class="is-size-5">Where did you get this information from?</h3>
            <p>
              We downloaded data tables directly from Statistics Canada's Census program, which is publicly available.
            </p>
            <h3 class="is-size-5">How can I access this information in a different format?</h3>
            <p>
              You can interact with the dataset in real time at the corresponding Data Tables, 2016 page. There, you can also download the file in a CSV, TAB, IVT (Beyond 20/20), 
              or XML format.
            </p>
            <h3 class="is-size-5">How often is this information updated?</h3>
            <p>
              The most current information we have is for 2016. The next census will be held in May 2021 and information will be available shortly thereafter.
            </p>
            <h3 class="is-size-5">How many people provided information?</h3>
            <p>
              Respondents are required by law to complete their census questionnaire, making it an extraordinarily thorough and robust product. Information was provided by the 
              total population of Canada.
            </p>
            <h3 class="is-size-5">What about sampling bias?</h3>
            <p>
              Because information is collected from all citizens, there are no sampling techniques being used.
            </p>
            <h3 class="is-size-5">What is the difference between what I see here and what is available from the Statistics Canada Data Tables?</h3>
            <p>
              We present complex information in a visual way that is quick and easy to understand. We also allow for easy comparisons between cities.
            </p>
            <p>
              However, we only present some of the information that is available. If you are looking for more detailed information (such as a breakdown by each individual year 
              of age), please consult the original Statistics Canada Data Tables.
            </p>
            <h3 class="is-size-5">Why can't I find information on other population characteristics, like ethnic diversity or income?</h3>
            <p>
              We are constantly seeking to grow and improve our products. If you have a suggestion for a new type of information you'd like to see, feel free to contact us 
              with your ideas.
            </p>`,
          faq_general: `
            <h2 class="is-size-4">General</h2>
            <h3 class="is-size-5">Why are certain industries named and grouped the way they are?</h3>
            <p>
              The information presented here is based on the most recent (2017) Canadian version of the 
              <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">North American Industry Classification System</a>. We use the 
              standard titles, definitions, and examples provided in the <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">NAICS handbook</a>.
            </p>
            <h3 class="is-size-5">Why can't I find information for my industry and/or location?</h3>
            <p>
              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield 
              results in any province selected.
            </p>
            <p>
              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of 
              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have 
              removed it from our collection.
            </p>
            <h3 class="is-size-5">Why am I being shown a different industry and/or location than the one I chose?</h3>
            <p>
              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most 
              similar industry or location for which information is available.
            </p>
            <p>
              In the case of location, this often means showing you national instead of provincial information.
            </p>
            <p>
              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not 
              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor 
              homes).
            </p>`,
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_pop: `
            <h2 class="is-size-4">Population, par sexe et âge</h2>
            <h3 class="is-size-5">Où avez-vous obtenu l'information?</h3>
            <p>
              Nous avons téléchargé les tableaux de données directement du programme de recensement de Statistique Canada, qui est disponible publiquement.
            </p>
            <h3 class="is-size-5">Comment puis-je accéder à cette information dans un format différent?</h3>
            <p>
              Vous pouvez interagir avec l'ensemble de données en temps réel à la page correspondante des tableaux de données de 2016. À cet endroit, vous pouvez aussi 
              télécharger un fichier dans un format CSV, TAB, IVT (Beyond 20/20) ou XML.
            </p>
            <h3 class="is-size-5">À quelle fréquence l'information est-elle mise à jour?</h3>
            <p>
              L'information la plus courante que nous avons est pour 2016. Le prochain recencement va être tenu en mai 2021 et l'information va être disponible peu de temps 
              après.
            </p>
            <h3 class="is-size-5">Combien de personne ont fourni de l'information?</h3>
            <p>
              Les répondants sont requis par la loi de compléter leur questionnaire du recencement, le fesant un produit extraordinairement complet et robuste. L'information a 
              été fourni par toute la population du Canada.
            </p>
            <h3 class="is-size-5">Que dites-vous du biais d'échantillonnage?</h3>
            <p>
              Parce que l'information est récolté par tous les citoyens, il n'y a pas de technique d'échantillonage qui est utilisé.
            </p>
            <h3 class="is-size-5">Quelle est la différence entre ce que je vois ici et ce qui est disponible par les tableaux de données de Statistique Canada?</h3>
            <p>
              Nous présentons l'information complexe dans une façon visuelle qui est vite et facile à comprendre. Nous permettons aussi des comparaisons faciles entre les villes.
            </p>
            <p>
              Cependant, nous présentons seulement quelque information qui est disponible. Si vous cherchez pour de l'information plus détaillée (tel qu'une décomposition par 
              chaque année d'âge), veuillez consulter les tableaux de données originaux de Statistique Canada.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver de l'information sur les autres caractéristiques de la population, comme la diversité ethnique ou le revenu?</h3>
            <p>
              Nous cherchons constament à développer et à améliorer nos produits. Si vous avez une suggestion pour un nouveau type d'information que vous voulez voir, 
              contactez nous avec vos idées.
            </p>`,
          faq_general: `
            <h2 class="is-size-4">Générale</h2>
            <h3 class="is-size-5">Pourquoi certains secteurs d'activités sont nommés et groupés de cette façon?</h3>
            <p>
              L'information présenté ici est basé sur la version canadienne la plus récente (2017) du 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">Système de classification des industries de l'Amérique du Nord</a>. 
              Nous utilisons les titres, les définitions et les exemples standards fourni dans le 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">guide du SCIAN</a>.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver l'information pour mon secteur d'activité et/ou l'emplacement?</h3>
            <p>
              L'information peut ne pas existé dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une espèce endémique du Canada donc l'agriculture 
              du coquelicot ne produirait probablement pas des résultats dans l'une ou l'autre des provinces sélectionnées.
            </p>
            <p>
              Parfois un secteur d'activité est représenté par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les données sans 
              faire abstraction à la protection de la vie privée de ses entrprises. En d'autre temps, l'information peut être inexacte ou manquant. Dans ces cas, Statistique 
              Canada a signalé les données comme un fonctionnement incertain et nous les avons retiré de notre collection.
            </p>
            <h3 class="is-size-5">Pourquoi je suis montré un secteur d'activité et/ou emplacement différent de ce que j'ai choisi?</h3>
            <p>
              Nous montrons toujours l'information la plus détaillé et spécifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va 
              montrer le secteur d'activité ou l'emplacement le plus similaire dont l'information est disponible.
            </p>
            <p>
              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.
            </p>
            <p>
              Dans le cas du secteur d'activité, ceci veut souvent dire qu'on vous montre l'information à partir d'un secteur plus générale au lieu d'un secteur d'activité 
              spécifique que vous avez choisi. Par exemple, nous n'avons peut-être pas l'information sur les centres de villégiature en particulier mais nous avons 
              l'information sur le secteur de l'hébergement des voyageurs (qui inclus centres de villégiature, hôtels, motels et maisons motorisées).
            </p>`,
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  }, // end i18n
  props: [
    'lang',
  ],
  mounted: function() {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function() {
      return this.lang;
    }
  }, // end computed
  methods: {
    print: function() {
      const d = new Printd();
      d.print(this.$refs.PrintBody);
    }
  } // end methods
}
</script>
